import { render } from "./DockFileManagerIcon.vue?vue&type=template&id=5335eeda&scoped=true"
import script from "./DockFileManagerIcon.vue?vue&type=script&lang=js"
export * from "./DockFileManagerIcon.vue?vue&type=script&lang=js"

import "./DockFileManagerIcon.vue?vue&type=style&index=0&id=5335eeda&scoped=true&lang=css"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5335eeda"]])

export default __exports__